import AddProtectedEnvironment from './AddProtectedEnvironment';

export default AddProtectedEnvironment;
